import axios, { AxiosResponse } from 'axios';
import endpoints from 'services/endpoints';
import { Branch } from 'types/types';

export const getBranchesForMerchant = (merchantId: string): Promise<AxiosResponse<Branch[]>> => {
  return axios.get(endpoints.merchants.BRANCHES(merchantId));
};
